import * as types from '../mutation-types'
import feepaymentService from '../../services/feepayments'
import { calcDiscount, getBillSum } from '../../common/index'

const state = {
  loading: false,
  errors: null,
  feepayments: [],
}

const actions = {
  getAll({ commit }) {
    commit(types.FEEPAYMENT_LOADING, true)
    feepaymentService.getAll().then(
      response => {

        commit(types.LOAD_FEEPAYMENTS, response.data)
        commit(types.FEEPAYMENT_LOADING, false)
        commit(types.FEEPAYMENT_FAILURE, null)
      },
      error => {
        commit(types.FEEPAYMENT_FAILURE, error)
        commit(types.FEEPAYMENT_LOADING, false)
      }
    )
  },
  add({ commit }, data) {
    commit(types.FEEPAYMENT_LOADING, true)
    commit(types.FEEPAYMENT_FAILURE, null)
    feepaymentService.add(data.fee_obj).then(
      response => {
        //data.id = response.data.id
        commit(types.ADD_FEEPAYMENT,{index:data.index,fobj:response.data} )
        commit(types.FEEPAYMENT_LOADING, false)

      },
      error => {
        commit(types.FEEPAYMENT_FAILURE, error)
        commit(types.FEEPAYMENT_LOADING, false)
      }
    )
  },
  update({ commit }, data) {
    commit(types.FEEPAYMENT_LOADING, true)
    commit(types.FEEPAYMENT_FAILURE, null)
    feepaymentService.update(data.discount_details)
      .then(
        response => {

          // console.log(response.data)
          data.dt = response.data
          commit(types.UPDATE_FEEPAYMENT, data)
          commit(types.FEEPAYMENT_LOADING, false)
        },
        error => {
          commit(types.FEEPAYMENT_FAILURE, error)
          commit(types.FEEPAYMENT_LOADING, false)
        }
      )


  },
  delete({ commit }, data) {
    commit(types.FEEPAYMENT_LOADING, true)
    commit(types.FEEPAYMENT_FAILURE, null)
    feepaymentService.delete(data.feepayment.id)
      .then(
        response => {

          commit(types.DELETE_FEEPAYMENT, data)
          commit(types.FEEPAYMENT_LOADING, false)
        },
        error => {
          commit(types.FEEPAYMENT_FAILURE, error)
          commit(types.FEEPAYMENT_LOADING, false)
        }
      )
  },


}

const mutations = {
  [types.ADD_FEEPAYMENT](state, payload) {

    const c_bills = this.state.billings.cls_billSums
    let x = state.feepayments[payload.index]
    x.s_payments.unshift(payload.fobj);
    let xsclassbill = getBillSum(x.class_id, c_bills)

    let xpc = JSON.parse(x.p_charges)
    let xpcharges =xpc? xpc.reduce((sum,val)=>{ //sum of all personal charges of student besides class bill
      return sum+=parseFloat(val.amount)
    },0):0

    let ottl_bill = xpcharges>0?parseFloat(xpcharges)+parseFloat(xsclassbill):xsclassbill
    let xsdiscval = calcDiscount(x.s_discount, ottl_bill)
    x.tot_paid = x.s_payments.reduce((sum, val) => {
      return sum + parseFloat(val.amount)
    }, 0)

    x.tot_bill = ottl_bill + Number(x.fees_arrears)

    x.remaining_fee = x.tot_bill - (Number(x.tot_paid) + Number(xsdiscval))
    x.fee_status = x.remaining_fee && x.remaining_fee > 0 ? "owing" : "fully paid"

    //console.log(payload)
    Object.assign(state.feepayments[payload.index], x);

  },



  [types.LOAD_FEEPAYMENTS](state, payload) {

    const c_bills = this.state.billings.cls_billSums

    //console.log("from payments store.....",c_bills)
    let new_payload = payload.map(x => {
      x.tot_paid = x.s_payments.reduce((sum, val) => {
        return sum + parseFloat(val.amount)
      }, 0)
       let xpc = JSON.parse(x.p_charges)

      let xpcharges =xpc? xpc.reduce((sum,val)=>{ //sum of all personal charges of student besides class bill
        return sum+=parseFloat(val.amount)
      },0):0

      let xsclassbill = getBillSum(x.class_id, c_bills)

      xpcharges = xsclassbill>0?xpcharges:0 //setting personal charges to 0 incase class has not been billed yet. just for display but in controller it will be used to calculate arrears remaining


      let ottl_bill = xpcharges>0?parseFloat(xpcharges)+parseFloat(xsclassbill):xsclassbill



      let xsdiscval = calcDiscount(x.s_discount, ottl_bill)
      //x.fees_arrears = xsclassbill>0?x.fees_arrears:0 //setting arrears to 0 for display purposes if class has not been billed
      x.fees_arrears = x.fees_arrears //setting arrears to 0 for display purposes if class has not been billed
      x.tot_bill = (ottl_bill + Number(x.fees_arrears || 0))

      //console.log("TOTAL BILLSSS",x.tot_bill)

      x.remaining_fee = x.tot_bill - (Number(x.tot_paid) + Number(xsdiscval))
      x.fee_status = x.remaining_fee && x.remaining_fee > 0 ? "owing" : "not owing"
     // x.fee_status = xsclassbill>0?x.fee_status:"Not Billed" //setting fee status to not billed for all students if class is not billed

      //console.log(x.remaining_fee)

      return x

    })

    //console.log(new_payload)
    state.feepayments = new_payload

  },



  [types.UPDATE_FEEPAYMENT](state, payload) {
    //console.log(payload.dt)
    const c_bills = this.state.billings.cls_billSums
    let x = payload.dt
    let xsclassbill = getBillSum(x.class_id, c_bills)
    let xpc = JSON.parse(x.p_charges)
    let xpcharges =xpc? xpc.reduce((sum,val)=>{ //sum of all personal charges of student besides class bill
      return sum+=parseFloat(val.amount)
    },0):0
    let ottl_bill = xpcharges>0?parseFloat(xpcharges)+parseFloat(xsclassbill):xsclassbill
    let xsdiscval = calcDiscount(x.s_discount, ottl_bill)

    x.tot_paid = x.s_payments.reduce((sum, val) => {
      return sum + parseFloat(val.amount)
    }, 0)

    x.tot_bill = (ottl_bill + Number(x.fees_arrears))

    x.remaining_fee = x.tot_bill - (Number(x.tot_paid) + Number(xsdiscval))
    x.fee_status = x.remaining_fee && x.remaining_fee > 0 ? "owing" : "fully paid"

    //console.log(payload)
    Object.assign(state.feepayments[payload.index], x);
  },
  [types.DELETE_FEEPAYMENT](state, payload) {
    const c_bills = this.state.billings.cls_billSums
    let x = state.feepayments[payload.index]

    if (!x) {
      x = state.feepayments.find(s => s.s_payments && s.s_payments.some(p => p.id == payload.feepayment.id))
    }

    if (!x) return

    if (x.s_payments) {
      x.s_payments = x.s_payments.filter(val => val.id != payload.feepayment.id)
    }

    let xpc = JSON.parse(x.p_charges ? x.p_charges : "[]")
    let xpcharges = xpc ? xpc.reduce((sum, val) => {
      return sum += parseFloat(val.amount)
    }, 0) : 0

    let xsclassbill = getBillSum(x.class_id, c_bills)

    xpcharges = xsclassbill > 0 ? xpcharges : 0

    let ottl_bill = xpcharges > 0 ? parseFloat(xpcharges) + parseFloat(xsclassbill) : xsclassbill

    let xsdiscval = calcDiscount(x.s_discount, ottl_bill)

    x.tot_paid = x.s_payments.reduce((sum, val) => {
      return sum + parseFloat(val.amount)
    }, 0)

    x.tot_bill = ottl_bill + Number(x.fees_arrears)

    x.remaining_fee = x.tot_bill - (Number(x.tot_paid) + Number(xsdiscval))
    x.fee_status = x.remaining_fee && x.remaining_fee > 0 ? "owing" : "fully paid"

    Object.assign(state.feepayments[payload.index], x);
  },
  [types.FEEPAYMENT_FAILURE](state, payload) {
    state.errors = payload
  },

  [types.FEEPAYMENT_LOADING](state, payload) {
    state.loading = payload
  },



}


const getters = {
  FEEPAYMENTS: state => {
    return state.feepayments
  },

  FEEPAYMENT_ERROR: state => {
    return state.errors
  },

  FEEPAYMENT_LOADING: state => {
    return state.loading
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/feepayments.js